// src/components/toggle/compare-toggle.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React2, { useCallback, useContext } from "react";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { useLocalization } from "@shared-ui/localization-context";
import { CompareAdaptExContext, TOGGLE_PLACEMENT_FILTERS_SHEET } from "@shared-ui/retail-compare-providers";
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkCard } from "uitk-react-cards";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkSwitch } from "uitk-react-switch";
// src/experiments.ts
var M1_EXPERIMENT = "M1_Web_SDUI_Property_Comparison_Tool_MVP_on_SRP";
// src/components/hocs/gated.tsx
import React from "react";
import { useExperiment } from "@shared-ui/experiment-context";
var gated = function(param) {
    var name = param.name, _param_bucket = param.bucket, bucket = _param_bucket === void 0 ? 1 : _param_bucket, _param_log = param.log, log = _param_log === void 0 ? true : _param_log;
    return function(Component) {
        var buckets = new Set(typeof bucket === "number" ? [
            bucket
        ] : bucket);
        var Gated = function(props) {
            var exposure = useExperiment(name, log).exposure;
            return buckets.has(exposure.bucket) ? /* @__PURE__ */ React.createElement(Component, _object_spread({}, props)) : null;
        };
        Gated.displayName = "gated(".concat(Component.displayName || Component.name || "Component", ")");
        return Gated;
    };
};
// src/components/toggle/compare-toggle.tsx
var CompareToggle = function(param) {
    var placement = param.placement;
    var track = useClickTracker();
    var _useContext = _sliced_to_array(useContext(CompareAdaptExContext), 2), state = _useContext[0], setState = _useContext[1];
    var handleToggle = useCallback(function() {
        var enabled = !state.enabled;
        setState(_object_spread_props(_object_spread({}, state), {
            enabled: enabled
        }));
        var status = enabled ? "on" : "off";
        track("HOT.SFP.PROPERTY.COMPARISON.toggle.click.".concat(status), "Comparison toggle SFP click ".concat(status));
    }, [
        state,
        setState
    ]);
    var formatText = useLocalization().formatText;
    var description = formatText(state.enabled ? "compare.toggle.description.on" : "compare.toggle.description.off");
    return placement !== TOGGLE_PLACEMENT_FILTERS_SHEET ? null : /* @__PURE__ */ React2.createElement(Viewport, null, /* @__PURE__ */ React2.createElement(ViewSmall, null, /* @__PURE__ */ React2.createElement(UitkSpacing, {
        padding: {
            blockstart: "six",
            inline: "four"
        }
    }, /* @__PURE__ */ React2.createElement("div", null, /* @__PURE__ */ React2.createElement(UitkSpacing, {
        padding: {
            blockend: "six",
            blockstart: "three"
        },
        border: [
            "blockend"
        ]
    }, /* @__PURE__ */ React2.createElement(UitkSwitch, {
        id: "compare-toggle-filter",
        switchPosition: "trailing",
        checked: state.enabled,
        onChange: handleToggle,
        description: description
    }, formatText("compare.toggle.label")))))), /* @__PURE__ */ React2.createElement(ViewLarge, null, /* @__PURE__ */ React2.createElement(UitkSpacing, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React2.createElement("div", null, /* @__PURE__ */ React2.createElement(UitkCard, {
        padded: true,
        border: true
    }, /* @__PURE__ */ React2.createElement(UitkLayoutFlex, null, /* @__PURE__ */ React2.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React2.createElement(UitkSwitch, {
        id: "compare-toggle-filter",
        switchPosition: "trailing",
        checked: state.enabled,
        onChange: handleToggle
    }, formatText("compare.toggle.label")))))))));
};
var GatedCompareToggle = gated({
    name: M1_EXPERIMENT,
    bucket: [
        1,
        2
    ],
    log: false
})(CompareToggle);
export { GatedCompareToggle as CompareToggle };
//# sourceMappingURL=index.js.map